import React from 'react';

import { lanesHeight } from '../shared/lanes';
import { positionRows } from '../shared/positionRows';
import { BORDER, cell } from '../shared/style';
import TimelineRowBody from '../shared/TimelineRowBody';
import MemberBars from './MemberBars';
import MemberNameCell from './MemberNameCell';
import { memberSegments } from './memberSegments';

// Jour non travaillé par le membre : hors de ses jours fixes, ou après la fin de son contrat.
const notWorkedBy = (dev) => (day) => {
  const devJt = dev.joursTravailles || [];
  return (
    (devJt.length > 0 &&
      !devJt.includes(day.d.getDay() === 0 ? 7 : day.d.getDay()) &&
      !day.we &&
      !day.ferie) ||
    (!!dev.dateFinContrat && day.iso > dev.dateFinContrat)
  );
};

/* Lignes de la Timeline, vue par membre : colonne des noms et zone des jours, déjà positionnées. */
export function buildMemberRows({ activeDevs, absencesByDev, appState, days, COL, openModal }) {
  const firstIso = days[0].iso,
    lastIso = days[days.length - 1].iso;
  const rows = activeDevs.map((dev) => {
    const affsDev = appState.affectations.filter((a) => a.devId === dev.id);
    const devAbs = absencesByDev[dev.id] || [];
    const { segs, nLanes } = memberSegments({ affsDev, devAbs, appState, firstIso, lastIso });
    const rowH = Math.max(58, lanesHeight(nLanes));
    const nameStyle = cell({
      background: '#fff',
      borderRight: BORDER,
      borderTop: BORDER,
      padding: '8px 12px',
      display: 'flex',
      alignItems: 'center',
      gap: 8,
      minHeight: rowH,
      overflow: 'hidden',
    });
    // Glisser sur la ligne : nouvelle affectation (ou absence) pour ce membre sur la période.
    const onSelect = (debut, fin) =>
      openModal(
        'aff',
        { devId: dev.id, userId: dev.id, devNom: dev.nom },
        {
          mode: 'aff',
          devId: dev.id,
          clientId: '',
          briqueId: '',
          debut,
          fin,
          heuresParJour: 7,
          absType: 'vacances',
          absDebutHalf: 'am',
          absFinHalf: 'pm',
        },
      );
    const name = <MemberNameCell key={dev.id} dev={dev} style={nameStyle} />;
    const body = (
      <TimelineRowBody
        key={dev.id}
        match={{ devId: dev.id }}
        notWork={notWorkedBy(dev)}
        onSelect={onSelect}
        style={{ gridColumn: `span ${days.length}`, borderTop: BORDER, minHeight: rowH }}
      >
        <MemberBars segs={segs} dev={dev} />
      </TimelineRowBody>
    );
    return { name, body, rowH };
  });
  return positionRows(rows, days.length * COL);
}
